module.exports = __webpack_public_path__ + "static/img/function-box-img1.e5e2ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcess/function-box-img1.png
// module id = iC1D
// module chunks = 0